import { getPlatformHosts, getSuperAdminHosts } from "../../../config/platformHosts";
import { isBareLocalhost } from "../../../utils/customerPortalDocument";

export default function getCustomerFromSubdomain() {
  const hostname = (window.location.hostname || "").toLowerCase();
  const platformHosts = getPlatformHosts();
  const superAdminHosts = getSuperAdminHosts();

  if (isBareLocalhost(hostname)) return null;

  if (superAdminHosts.some((h) => hostname === h)) return null;

  if (platformHosts.some((h) => hostname === h)) return null;

  if (hostname.includes("localhost")) {
    const parts = hostname.split(".");
    if (parts.length > 1 && parts[0] !== "localhost") return parts[0];
    return null;
  }

  const parts = hostname.split(".");
  if (parts.length >= 3) return parts[0];
  return null;
}
